import { Moon, Sun } from 'lucide-react';
import { useTheme } from './useTheme';

/**
 * Przelacznik motywu — single button toggle jasny/ciemny.
 *
 * Klient: "wywal jasny/ciemny/system, chce tylko 2 stany — klikam jasny,
 * klikam jeszcze raz ciemny. Nie potrzebuje dropdown."
 *
 * Logic: Sun icon gdy resolved='light' (klik -> dark), Moon icon gdy
 * resolved='dark' (klik -> light). System preference (useTheme `system`)
 * traktowane jako resolved aktualny — pierwszy klik ustawia OPPOSITE.
 *
 * Touch targets: min-h-touch min-w-touch (44px) mobile, h-9 w-9 desktop.
 * Identyczny layout jak inne ikony w Topbar (hamburger, bell, logout).
 */
export function ThemeToggle() {
  const { resolved, setPref } = useTheme();
  const isDark = resolved === 'dark';

  const toggle = () => {
    setPref(isDark ? 'light' : 'dark');
  };

  return (
    <button
      type="button"
      onClick={toggle}
      title={isDark ? 'Przełącz na motyw jasny' : 'Przełącz na motyw ciemny'}
      aria-label={isDark ? 'Przełącz na motyw jasny' : 'Przełącz na motyw ciemny'}
      className="inline-flex min-h-touch min-w-touch items-center justify-center rounded-md text-fg-muted transition-colors hover:bg-surface-2 hover:text-fg active:bg-surface-3 md:h-9 md:w-9 md:min-h-9 md:min-w-9"
    >
      {isDark ? (
        <Sun className="h-[18px] w-[18px]" strokeWidth={2} />
      ) : (
        <Moon className="h-[18px] w-[18px]" strokeWidth={2} />
      )}
    </button>
  );
}
